import { createSlice } from '@reduxjs/toolkit';
export var EShortFooterTheme;
(function (EShortFooterTheme) {
  EShortFooterTheme["primary"] = "primary";
  EShortFooterTheme["secondary"] = "secondary";
  EShortFooterTheme["dark"] = "dark";
})(EShortFooterTheme || (EShortFooterTheme = {}));
var initialState = {
  theme: EShortFooterTheme.secondary
};
var layoutSlice = createSlice({
  name: 'shortFooterLayout',
  initialState: initialState,
  reducers: {
    setShortFooterTheme: function setShortFooterTheme(state, _ref) {
      var payload = _ref.payload;
      state.theme = payload;
    }
  }
});
var setShortFooterTheme = layoutSlice.actions.setShortFooterTheme;
export { setShortFooterTheme };
export var layout = layoutSlice.reducer;